import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// input: 1-7-31
export default function CalendarIcon({ number }) {
    return <Box position="relative" display="inline-flex">
        <CalendarTodayIcon />
        <Box
            top={5}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <Typography
                variant="subtitle2"
                component="div"
                color="textSecondary"
                style={{ letterSpacing: "-0.1rem" }}
            >
                {number}
            </Typography>
        </Box>
    </Box>

}